<dialog
  #dialog
  qai-dialog
  [heading]="i18nKeys.modalHeading | transloco"
  [description]="description()"
  (afterClose)="onCancel()"
>

  <qai-field [label]="i18nKeys.fieldLabelTeam | transloco">
    <qai-multiselect
      [options]="teamOptions()"
      [value]="selectedTeamUuids()"
      [placeholder]="i18nKeys.searchTeamPlaceholder | transloco"
      (valueChange)="onTeamSelectionChange($event)"
    />
  </qai-field>

  <div class="action-button-container">
    <button
      qai-button
      kind="secondary"
      size="medium"
      (click)="onCancel()"
    >
      {{ i18nKeys.buttonCancel | transloco }}
    </button>
    <button
      qai-button
      kind="primary"
      size="medium"
      [disabled]="!canSave() || isSaving()"
      (click)="onSave()"
    >
      {{ i18nKeys.buttonSave | transloco }}
    </button>
  </div>

</dialog>
